<template>
  <div>
    <div class="search-wrapper border-outline mb-5 px-3 py-5 d-sm-flex justify-content-start">
      <div class="row">
        <div class="col-md-2">
          <v-text-field  v-on:keyup.enter="getIssuedBooks()" autofocus outlined dense v-model="search.barcode"
                        label="Student ID card no."></v-text-field>
        </div>
        <div class="col-md-2">
          <v-text-field v-on:keyup.enter="getIssuedBooks()" outlined dense v-model="search.name"
                        label="Symbol no., name, email"></v-text-field>
        </div>
        <div class="col-md-2">
          <v-text-field v-on:keyup.enter="getIssuedBooks()" outlined dense v-model="search.book_no"
                        label="Book No"></v-text-field>
        </div>
        <div class="col-md-2">
          <v-select v-on:keyup.enter="getIssuedBooks()" v-model="search.filter_by" :items="filter_type" item-text="title"
                    item-value="value" outlined dense
                    label="Filter By"></v-select>
        </div>
        <div class="col-md-2" v-if="search.filter_by == 'custom'">
          <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="search.dates"
                  label="Select dates"
                  prepend-inner-icon="mdi-calendar"
                  readonly v-on:keyup.enter="getIssuedBooks()"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="search.dates"
                range
            ></v-date-picker>

          </v-menu>
        </div>
        <v-col cols="2" md="2" class="text-right">
          <v-btn
              @click="getIssuedBooks()"
              class="btn btn-primary btn-search "
              :loading="loading"
          >
            <v-icon small elevation="2" outlined>fas fa-search</v-icon>&nbsp;
            Search
          </v-btn>
        </v-col>
<!--        <div class="col-md-6">
          <v-btn class="btn btn-primary mr-2 text-white" @click="getIssuedBooks">Search</v-btn>
          <v-btn class="btn btn-standard" @click="resetSearch">Reset</v-btn>
          <v-btn class="btn btn-primary ml-2 text-white" @click="exportIssueList">Export</v-btn>
        </div>-->
      </div>
    </div>
<!--    <div class="row bg-filter mb-5 mt-1">
      <div class="col-md-3">
        <v-text-field @keydown.enter="getIssuedBooks()" autofocus outlined dense v-model="search.barcode"
                      label="Student ID card no."></v-text-field>
      </div>
      <div class="col-md-3">
        <v-text-field @keydown.enter="getIssuedBooks()" outlined dense v-model="search.name"
                      label="Symbol no., name, email"></v-text-field>
      </div>
      <div class="col-md-3">
        <v-text-field @keydown.enter="getIssuedBooks()" outlined dense v-model="search.book_no"
                      label="Book No"></v-text-field>
      </div>
      <div class="col-md-3">
        <v-select @keydown.enter="getIssuedBooks()" v-model="search.filter_by" :items="filter_type" item-text="title"
                  item-value="value" outlined dense
                  label="Filter By"></v-select>
      </div>
      <div class="col-md-2" v-if="search.filter_by == 'custom'">
        <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="search.dates"
                label="Select by dates"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="search.dates"
              range
          ></v-date-picker>

        </v-menu>
      </div>
      <div class="col-md-6">
        <v-btn class="btn btn-primary mr-2 text-white" @click="getIssuedBooks">Search</v-btn>
        <v-btn class="btn btn-standard" @click="resetSearch">Reset</v-btn>
        <v-btn class="btn btn-primary ml-2 text-white" @click="exportIssueList">Export</v-btn>
      </div>
    </div>-->
    <v-skeleton-loader
        type="table-thead"
        v-if="loading"
    >
    </v-skeleton-loader>

    <v-skeleton-loader
        v-if="loading"
        type="table-row-divider@25"
    >
    </v-skeleton-loader>
    <div class="table-responsive">
      <table class="table ">
        <thead>
          <tr class="px-3">
          <th class="px-3">#</th>
          <th class="px-3" style="max-width: 300px !important; white-space: pre-wrap;">Book title</th>
          <th class="px-3"></th>
          <th class="px-3">User detail</th>
          <!--                  <th>Phone</th>-->
          <th class="px-3">Dates</th>
          <th class="pr-3 text-center">Action</th>
        </tr>
        </thead>
        <tbody v-if="issued_books.length>0">
        <tr v-for="(iss, i) of issued_books" :key="i">
          <td class="px-3">
            <div v-if="iss.book_no" class="text-secondary">
              {{ iss.book_no }}
            </div>
            <div v-if="iss.book_accession_no" class="text-secondary">
              {{ iss.book_accession_no }}
            </div>
          </td>
          <td class="px-3" style="max-width: 300px !important; white-space: pre-wrap;">
            <a @click.prevent="openBookDetail(iss)" class="">
              {{ iss.book_title }}
            </a>
            <div class="text-secondary">
              <span class="font-weight-medium">{{ iss.book_author }}</span>
            </div>
          </td>
          <td class="px-3"><img class="cursor-pointer img-thumbnail" @click="redirectTODetail(iss.user_id)" style="height: 80px"
                   v-if="iss.user_image" :src="iss.user_image" alt="">
            <span v-else>-</span>
          </td>
          <td style="cursor:pointer; color:blue"  @click="redirectTODetail(iss.user_id)">
            <div class="text-secondary">
              {{iss.user_id_card_no}} - {{iss.personal_id}}
            </div>
            <div class="text-secondary">
              {{iss.user_full_name}}
            </div>
            <div class="text-secondary">
              {{iss.program}}
            </div>
            <div class="text-secondary">
              {{iss.grade}}  - {{iss.class}}
            </div>
          </td>
          <!--                    <td>{{ iss.user_phone }}</td>-->
          <td>
            <div class="text-secondary">
              <span class="badge badge-secondary">Issue date: {{iss.issue_date_text ? iss.issue_date_text : '-' }}</span>
            </div>
            <div class="text-secondary  mt-3">
              <span class="badge badge-secondary">Renew date: {{
                iss.due_return_date_text ? iss.due_return_date_text : '-'
              }}</span>
            </div>
            <div class="text-secondary  mt-3">
              <span class="badge badge-secondary">Return date: {{iss.renew_date_text ? iss.renew_date_text : '-' }}
            </span>
            </div>
            <div class="text-secondary  mt-3 ml-2">
              Remaining days: <span class="font-weight-medium " :class="iss.renew_required?'text-danger':'text-success'">
                  {{`${iss.renew_required ? '-' + iss.remaining_renew_day : iss.remaining_renew_day}` }}
                </span>
            </div>
          </td>
          <td class="pr-0 text-center">
            <b-dropdown
                size="sm"
                variant="link"
                toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                no-caret
                right
                no-flip
            >
              <template v-slot:button-content>
                <slot>
                  <span>
                    <i class="flaticon-more-1"></i>
                  </span></slot>
              </template>
              <!--begin::Navigation-->
              <div class="navi navi-hover ">
                <!--                <b-dropdown-text tag="div" class="navi-item">-->
                <!--                  <a href="#" class="navi-link">-->
                <!--                        <span class="navi-icon">-->
                <!--                          <i class="fa fa-exchange-alt"></i>-->
                <!--                        </span>-->
                <!--                    <span class="navi-text">  Return </span>-->
                <!--                  </a>-->
                <!--                </b-dropdown-text>-->
                <b-dropdown-text v-if="checkIsAccessible('library-issue','extend-validity')" tag="div"
                                 class="navi-item" @click.prevent="openDialog(iss, 'renew')">
                  <a href="#" class="navi-link">
                        <span class="navi-icon">
                          <i class="fa fa-calendar-alt"></i>
                        </span>
                    <span class="navi-text"> Extend date</span>
                  </a>
                </b-dropdown-text>
                <b-dropdown-text v-if="checkIsAccessible('library-issue','cancel-and-return')" tag="div"
                                 class="navi-item" @click.prevent="openDialog(iss, 'return')">
                  <a href="#" class="navi-link">
                        <span class="navi-icon">
                          <i class="fa fa-stop"></i>
                        </span>
                    <span class="navi-text">  Cancel & return </span>
                  </a>
                </b-dropdown-text>

              </div>
              <!--end::Navigation-->
            </b-dropdown>
          </td>

        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="10">
            <p class="px-3 text-center">
              <strong>No data found</strong>
            </p>
          </td>
        </tr>
        </tbody>
      </table>
      <b-pagination
          v-if="issued_books.length > 0"
          class="pull-right mt-7"
          @input="getIssuedBooks"
          v-model="page"
          :total-rows="total"
          :per-page="perPage"
          first-number
          last-number
      ></b-pagination>
    </div>

    <return-or-renew ref="return-renew" :dialog="renew_dialog" :issue="issue" :type="type"
                     @close_dialog="closeDialog"></return-or-renew>
  </div>
</template>

<script>
import userService from "@/core/services/user/UserService";
import IssueService from "@/core/services/library/issue/IssueService";
import DashboardService from "@/core/services/dashboard/DashboardService";
import ReturnOrRenew from "@/view/pages/library/book/Modals/ReturnOrRenew";

const issueService = new IssueService();
const user = new userService();
const dashboardService = new DashboardService();

export default {
  validations: {},
  name: "search-user.vue",
  components: {
    ReturnOrRenew
  },
  data() {
    return {
      filter_type: [
        {'title': 'Today', 'value': 'today'},
        {'title': 'Yesterday', 'value': 'yesterday'},
        {'title': 'Current Week', 'value': 'this_week'},
        {'title': 'Last Week', 'value': 'last_week'},
        {'title': 'This Month', 'value': 'this_month'},
        {'title': 'Custom', 'value': 'custom'},
        {'title': 'All', 'value': 'all'},
      ],
      users: [],
      issued_books: [],
      issue: {},
      loading: false,
      attrs: '',
      renew_dialog: false,
      type: null,
      page: 1,
      total: null,
      menu: false,
      perPage: null,
      total_issued: 0,
      stats: {},
      search: {
        status: null,
        dates: [],
        name: null,
        book_no: null,
        filter_by: 'all',
        type: 'issued-list'
      }
    }
  }, computed: {},

  mounted() {
    this.getIssuedBooks()
    this.getStats()
  }, methods: {
    getStats() {
      dashboardService.getLibraryStat().then((res) => {
        this.stats = res.data;
      })
    },
    searchUser() {
      user.paginate(this.search).then(response => {
        this.users = response.data.data
      })
    },
    resetSearch() {
      this.search = {
        status: null,
        dates: [],
        name: null,
        book_no: null,
        type: 'issued-list'
      }
      this.getIssuedBooks()
    },
    redirectTODetail(id) {
      this.$router.push({name: 'issue-return-detail', params: {id: id}})
    },
    getIssuedBooks() {
      this.loading = true
      issueService.paginate(this.search, this.page).then(response => {
        this.loading = false
        this.issued_books = response.data.data
        this.page = response.data.meta.current_page;
        this.total = response.data.meta.total;
        this.perPage = response.data.meta.per_page;
        this.total_issued = response.data.meta.total;
      })
    }, renewBook(issue) {
      this.$confirm({
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            issueService.update(issue.id, issue).then(response => {
              this.$snotify.success("Book renewed successfully")
              this.getIssuedBooks()
            })
          }
        }
      })
    },
    openDialog(issue, type) {
      this.renew_dialog = true
      this.issue = issue
      this.type = type
      this.$refs['return-renew'].showModal()

    },

    closeDialog() {
      this.issue = {}
      this.issue.renew_date = null;
      this.issue.return_date = null;
      this.type = null
      this.renew_dialog = false
      this.getIssuedBooks();
    },
    userDetail(issue) {
      let user = "";
      user += issue.user_id_card_no ? issue.user_id_card_no + " - " : "";
      user += issue.personal_id ? issue.personal_id + "<br>" : "";
      user += issue.user_full_name ? issue.user_full_name + "<br>" : "";
      user += issue.program ? issue.program + "<br>" : "";
      user += issue.grade ? issue.grade + " - " : "";
      user += issue.class ? issue.class + "<br>" : "";
      return user;
    },
    exportIssueList() {
      this.$confirm({
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: confirm => {
          if (confirm) {
            issueService.exportIssueList(this.search);
          }
        }
      });
    },
    openBookDetail(item){
      this.$router.push({
        name: "book-detail",
        params: { id: item.book_id }
      });
    },
  }
}
</script>

<style scoped>

</style>